<template>
  <div class="order-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.claimStatus" placeholder="全部" clearable style="width: 130px">
            <el-option label="待领取" :value="0"></el-option>
            <el-option label="已核销" :value="1"></el-option>
            <el-option label="已取消" :value="2"></el-option>
            <el-option label="已过期" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="订单号/商品名"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <el-form-item label="领取人">
          <el-input
              v-model="searchForm.realName"
              placeholder="领取人"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="orderNo" label="订单号" width="160"></el-table-column>
        <el-table-column prop="realName" label="领取人" width="100"></el-table-column>
        <el-table-column label="类型" width="110">
          <template slot-scope="{ row }">
            <el-tag :type="personTypeTagType(row.personType)" size="small">
              {{ row.personType || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="communityName" label="所属社区" width="100"></el-table-column>
        <el-table-column prop="productName" label="商品名称" min-width="160"></el-table-column>
        <el-table-column label="商品类型" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.ownerType === 1 ? 'success' : 'warning'">
              {{ row.ownerType === 1 ? '社区' : '商户' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" label="商品所属门店" min-width="140"></el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.claimStatus)" size="small">
              {{ statusText(row.claimStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="verifyCode" label="核销码" width="110" align="center"></el-table-column>
        <el-table-column prop="createdAt" label="预约时间" width="160"></el-table-column>
        <el-table-column prop="expireTime" label="领取截止" width="160">
        </el-table-column>
        <el-table-column label="核销时间" width="160">
          <template slot-scope="{ row }">
            {{ formatTime(row.verifyTime) }}
          </template>
        </el-table-column>
<!--        <el-table-column label="操作" width="120" fixed="right">-->
<!--          <template slot-scope="{ row }">-->
<!--            <el-button-->
<!--              v-if="row.claimStatus === 0"-->
<!--              size="mini"-->
<!--              type="danger"-->
<!--              @click="handleCancel(row)"-->
<!--            >取消订单</el-button>-->
<!--            <el-button v-else size="mini" type="primary" @click="showDetail(row)">详情</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 取消订单弹窗 -->
    <el-dialog title="取消订单" :visible.sync="cancelVisible" width="400px">
      <el-form>
        <el-form-item label="取消原因">
          <el-input v-model="cancelReason" type="textarea" :rows="3" placeholder="请输入取消原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelVisible = false">取 消</el-button>
        <el-button type="danger" :loading="submitting" @click="doCancel">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="detailVisible" width="550px">
      <el-descriptions :column="1" border v-if="detail.id">
        <el-descriptions-item label="订单号">{{ detail.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ detail.productName }}</el-descriptions-item>
        <el-descriptions-item label="商家名称">{{ detail.merchantName }}</el-descriptions-item>
        <el-descriptions-item label="核销码">{{ detail.verifyCode }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="statusType(detail.claimStatus)" size="small">
            {{ statusText(detail.claimStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="取消原因">{{ detail.cancelReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detail.createdAt) }}</el-descriptions-item>
        <el-descriptions-item label="核销时间">{{ formatTime(detail.verifyTime) }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, cancelOrder, getOrderDetail } from '@/api/order'
import {getPersonTypeList} from "@/api/user";

export default {
  name: 'OrderList',
  data() {
    return {
      searchForm: { claimStatus: '', keyword: '', realName: '', verifyCode: '' },
      tableData: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      cancelVisible: false,
      cancelReason: '',
      currentRow: null,
      submitting: false,
      detailVisible: false,
      detail: {},
      // 由 /personTypes/list 动态填充，不再硬编码
      personTypeOptions: [],
      // label -> tagType，供表格 tag 取色
      personTypeMap: {},
    }
  },
  mounted() { this.loadData();this.loadPersonTypes() },
  methods: {
    async loadPersonTypes() {
      try {
        const res = await getPersonTypeList()
        // 兼容 R<T> 包装与裸数组两种返回结构
        const raw = res && res.data != null ? res.data : res
        const list = (raw && (raw.records || raw.list || raw.items)) || raw || []
        if (!Array.isArray(list) || !list.length) {
          throw new Error('empty')
        }
        // 后端 sort 可能缺省，按数组下标兜底，保证展示顺序稳定
        const sorted = [...list].sort(
            (a, b) => (a.sort == null ? 0 : a.sort) - (b.sort == null ? 0 : b.sort)
        )
        this.personTypeOptions = sorted
            .filter(i => i && i.label)
            .map(i => ({ label: i.label, value: i.label, code: i.code }))
        this.personTypeMap = sorted.reduce((m, i) => {
          if (i && i.label) m[i.label] = i.tagType || ''
          return m
        }, {})
      } catch (e) {
        // 接口异常时降级，避免下拉框为空导致无法编辑
        this.personTypeOptions = FALLBACK_PERSON_TYPES.map(i => ({
          label: i.label,
          value: i.label,
          code: i.code
        }))
        this.personTypeMap = FALLBACK_PERSON_TYPES.reduce((m, i) => {
          m[i.label] = i.tagType
          return m
        }, {})
      }
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getOrderList(this.searchForm.claimStatus, this.searchForm.keyword, this.searchForm.realName,this.searchForm.verifyCode, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { claimStatus: '', keyword: '', realName: '',verifyCode:''}; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    statusType(s) {
      const map = { 0: 'warning', 1: 'success', 2: 'info', 3: 'danger' }
      return map[s] || ''
    },
    statusText(s) {
      const map = { 0: '待领取', 1: '已核销', 2: '已取消', 3: '已过期' }
      return map[s] || '-'
    },
    handleCancel(row) { this.currentRow = row; this.cancelReason = ''; this.cancelVisible = true },
    personTypeTagType(type) {
      if (!type) return ''
      return this.personTypeMap[type] || ''
    },


    async doCancel() {
      this.submitting = true
      try {
        await cancelOrder(this.currentRow.id, this.cancelReason)
        this.$message.success('订单已取消')
        this.cancelVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    async showDetail(row) {
      try {
        this.detail = await getOrderDetail(row.id)
        this.detailVisible = true
      } catch (e) {}
    },
    formatTime(t) { return t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : '-' }
  }
}
</script>

<style scoped>
.order-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
